// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__28dwt","label":"Radio_label__WhLRR","checkMark":"Radio_checkMark__2yhsf","disabled":"Radio_disabled__l1qAR"};